module.exports = (require("./helpers/browser/import-polyfill")(require('./helpers/bundle-manifest').resolve("f2uOF"))).then(() => parcelRequire('9uERg'));